import { render, staticRenderFns } from "./ArtworkView.vue?vue&type=template&id=f79dfd56"
import script from "./ArtworkView.vue?vue&type=script&lang=js"
export * from "./ArtworkView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports